<template>

  <b-card
      no-body
      class="vb-card-recap"
  >
    <b-card-header class="vb-card-recap__header text text--base text-primary semibold">
      <div class="vb-card-recap__header-item">
        <vb-icon
            :name="'calendar'"
            :size=20
            :color="sass('primary')"
            class="mr-1"
        />
        {{parse_date(selected_room.data_andata).day_number}} {{parse_date(selected_room.data_andata).month_string}} {{parse_date(selected_room.data_andata).year}} -
        {{parse_date(selected_room.data_ritorno).day_number}} {{parse_date(selected_room.data_ritorno).month_string}} {{parse_date(selected_room.data_ritorno).year}}
        ({{selected_room.quote_payload.days}} notti)
      </div>
      <div class="vb-card-recap__header-item">
        <vb-icon
            :name="'occupants'"
            :size=20
            :color="sass('primary')"
            class="mr-1"
        />
        {{selected_room.quote_payload.paxA + (selected_room.quote_payload.paxA > 1 ? ' adulti' : ' adulto')}}
        <span class="ml-1" v-if="selected_room.quote_payload.paxC > 0">+ {{selected_room.quote_payload.paxC + (selected_room.quote_payload.paxC > 1 ? ' bambini ' : ' bambino')}}</span>
        <span class="ml-1" v-if="selected_room.quote_payload.paxI > 0">+ {{selected_room.quote_payload.paxI + (selected_room.quote_payload.paxI > 1 ? ' infanti' : ' infante')}}</span>
      </div>
      <div v-if="selected_room.aeroporto_partenza_andata"
        class="vb-card-recap__header-item">
        <span class="d-flex align-items-center">
          <vb-icon
            :name="'airplane'"
            :size=20
            :color="sass('primary')"
            class="mr-1"
          />
          da&nbsp;<span class="text-capitalize">{{selected_room.aeroporto_partenza_andata.toLowerCase()}}</span>&nbsp;({{selected_room.aeroporto_partenza_andata_code}})
        </span>
        &nbsp;
        <span>
          a&nbsp;<span class="text-capitalize">{{selected_room.aeroporto_arrivo_andata.toLowerCase()}}</span>&nbsp;({{selected_room.aeroporto_arrivo_andata_code}})
        </span>
      </div>
    </b-card-header>
    <b-card-body>
      <b-card-title class="vb-card-recap__title">
        <span class="vb-card-recap__title-item regular">
          <vb-icon
              :name="'bed'"
              :size=17
              :color="sass('primary')"
              class="mr-1"
          />{{selected_room.quote_payload.roomDescription.toLowerCase()}}
        </span>
        <span class="vb-card-recap__title-item regular">
          <vb-icon
              :name="'cutlery'"
              :size=17
              :color="sass('primary')"
              class="mr-1"
          />{{selected_room.quote_payload.roomTrattDescription.toLowerCase()}}
        </span>
        <span class="vb-card-recap__title-item regular">
          <vb-icon
              :name="'bus'"
              :size=17
              :color="sass('primary')"
              class="mr-1"
          />Trasferimenti inclusi <span class="text-primary">*</span>
        </span>
<!--        <span class="vb-card-recap__title-item h5 regular" v-b-modal="'insurance'">
          <vb-icon
              :name="'shield'"
              :size=17
              :color="sass('primary')"
              class="mr-1"
          />Assicurazione
          <vb-icon
              class="ml-1"
              :name="'info'"
              :color="sass('gray-500')"
              :size="14"
          />
        </span>-->

        <vb-modal :vb_options="{
          id: 'insurance',
          size: 'lg',
          title: 'I pacchetti viaggio includono',
          hide_footer: true,
        }">
         <services-insurance class="p-0 mt-0" />
        </vb-modal>

      </b-card-title>
      <b-card-text class="vb-card-recap__note">
        <span>
          Il prezzo che vedi è già comprensivo delle riduzioni o eventuali gratuità previste per i bambini.
        </span>
        <span>
          <strong class="vb-card-recap__note-transfers">*I trasferimenti potrebbero non essere sempre inclusi.</strong>
          Per maggiori dettagli, verifica le informazioni presenti nel pacchetto scelto o contatta la nostra assistenza.
        </span>
      </b-card-text>
      <div class="vb-card-recap__footer">
        <insufficient-credit-alert
          :availability="availability"
          :total_price="markup(selected_room.quote_payload.totAmount).display_price"
          class_name="vb-card-recap__nocredit"
          icon_class_name="vb-card-recap__nocredit-icon ml-1"
          cta_id="alpitour-card-recap-insufficient-credit"
        />
        <span
          class="vb-card-recap__amount text-primary"
          :class="availability.is_known && availability.total < markup(selected_room.quote_payload.totAmount).display_price ? 'text-dark' : ''"
        >
          € {{markup(selected_room.quote_payload.totAmount).display_price}}
          <em class="vb-card-recap__amount-perpax">
            (€ {{round(divide(markup(selected_room.quote_payload.totAmount).display_price, (Number(selected_room.quote_payload.paxA) + Number(selected_room.quote_payload.paxC) + Number(selected_room.quote_payload.paxI))), 2)}}/pers.)
          </em>
        </span>
      </div>
    </b-card-body>
  </b-card>

</template>

<script>
import { parse_date } from '@utilities/commons' 
import { round, divide } from 'mathjs'
import ServicesInsurance from '@alpitour/components/blocks/detail/assicurazione-medico-bagaglio.vue'
import InsufficientCreditAlert from '@alpitour/components/atoms/insufficient-credit-alert.vue'
export default {
  name: 'card-recap-flight-and-stay',
  props: {
    selected_room: Object
  },
  components: {
    'services-insurance': ServicesInsurance,
    'insufficient-credit-alert': InsufficientCreditAlert,
  },
  created() {
    this.parse_date = parse_date
  },
  computed: {
    availability() {
      return this.get_availability()
    }
  },
  methods: {
    round,
    divide,
  }
}
</script>

<style lang="scss">

%vb-card-recap__item {
  display: flex;
  align-items: center;
  flex-basis: 100%;
  margin-bottom: .625rem;

  &:last-child {
    margin-bottom: 0;
  }

  @include media-breakpoint-up(md) {
    flex-basis: auto;
    margin-right: 15px;

    &:last-child {
      margin-right: 0;
    }
  }

  @include media-breakpoint-up(xl) {
    margin-bottom: 0;
  }
}

.vb-card-recap {

  &__header {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    background-color: transparent;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border-radius: inherit;
      background-color: var(--primary);
      opacity: .03;
      pointer-events: none;
    }

    &-item {
      @extend %vb-card-recap__item;

      @at-root .card-header & {
        &:last-child {
          display: block;
          
          @include media-breakpoint-up(sm) {
            display: flex;
          }
        }
      }
    }
  }

  &__title {
    text-transform: capitalize;
    display: flex;
    flex-wrap: wrap;

    &-item {
      font-size: $font-size-base;
      line-height: 2rem;
      @extend %vb-card-recap__item;
    }
  }

  &__note {

    span {
      display: block;
    }

    &-transfers {
      color: var(--primary);
      font-weight: $vb-font-weight-semibold;
    }
  }

  &__footer {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    justify-content: flex-end;
    gap: $grid-gutter-width/2;
    margin-top: $grid-gutter-width/2;
    padding-top: $grid-gutter-width/2;
    border-top: 1px solid $gray-200;
  }

  &__amount {
    font-size: $font-size-lg;
    font-weight: $vb-font-weight-semibold;

    &-perpax {
      font-size: $font-size-sm;
      font-weight: $font-weight-normal;
      color: $gray-600;
    }
  }

  &__nocredit {
    display: flex;
    align-items: baseline;
    justify-content: flex-end;
    font-weight: $vb-font-weight-semibold;
    font-size: $font-size-md;
  }
}

</style>
